import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";

export default function UserCard({
  children,
  name,
  filename,
  phone,
  email,
  link,
  pathPrefix,
  subtitle,
}) {
  const contactMethods = [
    { key: 0, icon: "phone", value: phone },
    { key: 1, icon: "send", value: email },
  ].filter((f) => f.value);

  return (
    <div className="user-card">
      <div className="meta" style={{ paddingBottom: children ? "15px" : "0" }}>
        {filename && (
          <img src={`${pathPrefix}/api/avatars/${filename}`} alt={name} />
        )}
        {!filename && (
          <Icon name="user circle" size="huge" className="default-avatar" />
        )}
        <div>
          <div className="name">
            <p>{name}</p>
            {link && (
              <Link to={link}>
                <Icon name="external alternate" />
              </Link>
            )}
          </div>
          {subtitle && <small className="subtitle">{subtitle}</small>}
          <div className="contact-methods">
            {contactMethods.map(({ key, icon, value }) => (
              <span key={key}>
                <Icon name={icon} /> {value}
              </span>
            ))}
          </div>
        </div>
      </div>
      {children && <div className="extra">{children}</div>}
    </div>
  );
}

UserCard.defaultProps = {
  email: "",
  filename: "",
  link: "",
  name: "",
  phone: "",
  pathPrefix: "",
  subtitle: "",
};
